import { inject, Injectable } from '@angular/core';
import { FilterOption, PDropdownOptions } from 'shared-library';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ProviderUtilizationLogicServiceService {
  constructor(private translate: TranslateService) { }


  buildFilters(yearOptions: PDropdownOptions[]) {
    return [this.buildProviderUtilizationFilters(yearOptions)];
  }

  /** Prepends an "All" option to the year list returned by the backend. */
  buildYearOptions(years: PDropdownOptions[]): PDropdownOptions[] {
    return [
      { label: this.translate.instant('REPORT_FILTERS.ALL'), value: 'All' },
      ...years,
    ];
  }

  private buildProviderUtilizationFilters(yearOptions: PDropdownOptions[]): FilterOption[] {
    return [
      {
        label: this.translate.instant('REPORT_FILTERS.YEARS'),
        key: 'years',
        dropdownOptions: yearOptions,
      },
      {
      label: this.translate.instant('REPORT_FILTERS.QUARTER.QUARTER'),
      key: 'quarter',
      dropdownOptions: [
        { label: this.translate.instant('REPORT_FILTERS.QUARTER.ALL'), value: 'All' },
        { label: 'Q1', value: '1' },
        { label: 'Q2', value: '2' },
        { label: 'Q3', value: '3' },
        { label: 'Q4', value: '4' },
      ],
    },
    {
      label: this.translate.instant('REPORT_FILTERS.CONTRACT_TYPE.CONTRACT_TYPE'),
      key: 'contractType',
      dropdownOptions: [
        { label: this.translate.instant('REPORT_FILTERS.CONTRACT_TYPE.ALL'), value: 'All' },
        { label: this.translate.instant('REPORT_FILTERS.CONTRACT_TYPE.INDIVIDUAL_LIFE'), value: 'Ατομικά' },
        { label: this.translate.instant('REPORT_FILTERS.CONTRACT_TYPE.GROUP'), value: 'Ομαδικά' },
      ],
    },
  ];
  }
}
